import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import type { ActivityLog } from 'dico-types';
import { listWorkspaceActivityLogs } from '@/lib/api/activity-log/activityLogApi';
import { MonoIcon } from '@/components/ui/MonoIcon';
import { useIntegrationStore } from '@/stores/integration-store';
import { ActivityLogList } from './ActivityLogList';
import { toast } from 'sonner';

export function EventsTabContent() {
  const { id: workspaceId } = useParams<{ id: string }>();
  const [logs, setLogs] = useState<ActivityLog[]>([]);
  const [loading, setLoading] = useState(true);
  const { accounts, load } = useIntegrationStore();

  useEffect(() => {
    if (!workspaceId) return;

    const fetchLogs = async () => {
      try {
        setLoading(true);
        const data = await listWorkspaceActivityLogs(workspaceId, { limit: 100 });
        setLogs(data);
      } catch (err) {
        toast.error(err instanceof Error ? err.message : 'Failed to load activity logs');
      } finally {
        setLoading(false);
      }
    };

    fetchLogs();
  }, [workspaceId]);

  useEffect(() => {
    if (!workspaceId) return;
    load(workspaceId);
  }, [workspaceId, load]);

  return (
    <div className="w-3xl mx-auto min-h-full flex-1 px-8 py-10 xl:border-x">
      <div className="mb-6">
        <h1 className="text-xl font-semibold tracking-tight">Events</h1>
        <p className="text-muted-foreground mt-1 text-sm">Recent activity and system events</p>
      </div>

      {loading && (
        <div className="flex items-center justify-center py-12">
          <MonoIcon type="Loader2" className="text-muted-foreground h-6 w-6 animate-spin" />
        </div>
      )}

      {!loading && (
        <ActivityLogList
          logs={logs}
          accounts={accounts}
          workspaceId={workspaceId ?? ''}
          error={null}
        />
      )}
    </div>
  );
}
